import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import Header from '../sharedFiles/header/header';
import Footer from '../sharedFiles/footer/footer';
import { TextField } from '@mui/material';
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import './attendance.css';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../ReduxStore/userReducer';
import { getAttendanceByUser, getLocation, PostAttendance, updateAttendance } from '../API/API';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useOutsideAlerter } from '../sharedFiles/dropdownCloser/dropdownCloser';
import { PostData } from '../API/postApi';
import { GetData } from '../API/getApi';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Swal from 'sweetalert2';

const Attendance = () => {
    const [location, setLocation] = useState({ lat: 0, lng: 0 });
    const userData = useSelector(selectUser);
    const jwtToken = userData?.JwtToken
    const [locationData, setLocationData] = useState();
    const [attendanceValue, setAttendanceValue] = useState();
    const [attendanceId, setAttendanceId] = useState();
    const [show,setshow]=useState(false);
    const [AttendanceStatus, setAttendanceStatus] = useState(null); 
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [attendanceList, setAttendanceList] = useState([]);
    const [checkInData, setCheckInData] = useState(false);
    const [Error, setError] = useState(false);
        // { id: 1, name: 'Present' },
        // { id: 2, name: 'Finished' },
        // { id: 3, name: 'Absent' }
      
    const wrapperRef = React.useRef(null);
    useOutsideAlerter(wrapperRef, () => setshow(false));
    // console.log("locationData :", getAttendanceByUser+userData.UserId);
    useEffect(() => {
        const fetchGetCityName = (url) => {
          fetch(url)
            .then(response => response.json())
            .then(data => setLocationData(data))
            .catch(error => console.error('Error fetching city name:', error));
        };
    
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const latitude = position.coords.latitude;
              const longitude = position.coords.longitude;
              setLocation({ lat: latitude, lng: longitude });
    
              const url = `${getLocation}${latitude}&longitude=${longitude}&localityLanguage=en&key=bdc_094c4a1a617b4fb1b2fc7f38401b8279`;
              fetchGetCityName(url);
            },
            (error) => {
              console.error('Error getting location:', error);
            }
          );
        } else {
          console.error('Geolocation is not supported by this browser.');
        }
        fetchAttendanceByUser();
      }, []);
    const handleBackNav = () => {
        navigate("/DashBoard")
    }

    const handleShow = () => {
      setshow(true);
    }
    const handleAttenClick = (item) => {
      setshow(false);
      setAttendanceValue(item.name)
      setAttendanceId(item.id)
    }

    const handleCheckIN = async () => {
      const isFound = AttendanceStatus?.isFound
      const attendanceData = AttendanceStatus?.attendanceData
      const startLocation = locationData?.city +" "+ location.lat + '-' + location.lng;
      const dataTosend ={
        D_UserId : userData?.UserId,
        D_Status : attendanceId,
        D_UserName :userData?.UserName,
        D_EmpUCode : userData?.EmpCode,
        // D_SDateTime
        // D_EDateTime
        D_DatabaseName : userData?.DatabaseName,
        D_CompanyName  : userData?.CompanyName,
        D_Location : startLocation,
        D_EndLocation : ""
        }
        if (!(isFound && (attendanceData?.[0]?.d_Status === 2 || attendanceData?.[0]?.d_Status === 3))) {
        try {
          // const response = await PostData(updateAttendance,updateAttendances,jwtToken,dispatch,navigate)
          const response = await PostData(PostAttendance, dataTosend, jwtToken,dispatch,navigate)          
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Attendance marked successfully! Have a great day",
            showConfirmButton: false,
            timer: 2000
          });
          fetchAttendanceByUser();
          setAttendanceValue("")
        } catch (error) {
          // console.log("error  :" , error);
        }
      }else {
        setError(true);

        if(attendanceData?.[0]?.d_Status === 2){
          toast('already logout for today', {
            position: "bottom-right",
            // theme: "dark",
            style: {
              backgroundColor: '#182e49', // Customize the background color
              color: '#fff', // Customize the text color
          },
          progressStyle: {
              background: '#ffba17' // Customize the progress bar color
          }
          });
        }
        if(attendanceData?.[0]?.d_Status === 3) {
          toast('already marked your attendance as a absent', {
            position: "bottom-right",
            theme: "dark",
              style: {
                backgroundColor: '#182e49', // Customize the background color
                color: '#fff', // Customize the text color
            },
            progressStyle: {
                background: '#ffba17' // Customize the progress bar color
            }
          });
        }
      }
    }
    const handleCheckOut = async() => {
      const isFound = AttendanceStatus.isFound
      const attendanceData = AttendanceStatus.attendanceData
      const startLocation = locationData?.city +" "+ location.lat + '-' + location.lng;
      const updateAttendances = {
        D_UserId : userData?.UserId,
        D_Status : attendanceId,
        D_UserName :userData?.UserName,
        D_EmpUCode : userData?.EmpCode,
        D_DatabaseName : userData?.DatabaseName,
        D_CompanyName  : userData?.CompanyName,
        D_EndLocation : startLocation,
        D_Location :""
      }
      if (!(isFound && (attendanceData?.[0]?.d_Status === 2))) {
        try {
         const response = await PostData(updateAttendance,updateAttendances,jwtToken,dispatch,navigate)
         Swal.fire({
          position: "center",
          icon: "success",
          title: "Logged out successfully",
          showConfirmButton: false,
          timer: 2000
        });
         setAttendanceValue("");
         fetchAttendanceByUser();
        } catch (error) {
          // console.log("error  :" , error);
        }
      }
      }

    const fetchAttendanceByUser = async () => {
      try {
        const response = await axios.get(getAttendanceByUser+userData.UserId, {
            headers: {
              'wg_token': jwtToken
            }
      })
      setAttendanceStatus(response.data)
      const isFound = response.data.isFound
      const attendanceData = response.data.attendanceData
        if (isFound && (attendanceData?.[0]?.d_Status === 1)){
          setCheckInData(true);
          setAttendanceList([
            { id: 2, name: 'Finished' }
          ])
          // setAttendanceList([
          //   { id: 1, name: 'Present' },
          //   { id: 3, name: 'Absent' }
          // ])
        }
        if (isFound && (attendanceData?.[0]?.d_Status === 2)) {
          setCheckInData(false);
        }
        if (isFound && (attendanceData?.[0]?.d_Status === 3)) {
          setAttendanceList([]);
        }
        if (!isFound){
          setCheckInData(false);
          setAttendanceList([
              { id: 1, name: 'Present' },
              { id: 3, name: 'Absent' }
            ])
        }

      } catch (error) {
        // console.log("Get Error :", error);
      }
    }
  return (
    <>
    <Header/>
    <div className='customerCreation'>
        <div className='dashImage'></div>
        <div className='dashGradient z-1'>
            <div className='TopDiv'>
                <div className=' d-flex col-5'>
                    <button onClick={handleBackNav} className="backIcondiv">
                        <ArrowCircleLeftIcon />
                    
                    <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">
                        Dashboard
                    </p>
                    </button>
                </div>
                <div className='attendanceTitle'>
                    <p>Attendance Marking </p>
                </div>
            </div>
        </div>
        <div className='StepperGradient2'>
            <div className='insideDiv'>
            <div className='errorTextField textfieldAttendance'>
               <TextField 
                    id="EmployeeName"
                    name="EmployeeName"
                    label="Employee Name"
                    variant="outlined"
                    value={userData?.UserName}
                    className='SecondRowStepper'
                    autoComplete='off'
                    // disabled
                    />
            </div>
            <div className='errorTextField textfieldAttendance'>
               <TextField 
                    id="EmployeeCode"
                    name="EmployeeCode"
                    label="Employee Code"
                    variant="outlined"
                    value={userData?.UserId}
                    className='SecondRowStepper'
                    autoComplete='off'
                    // disabled
                    />
            </div>
            <div className='errorTextField textfieldAttendance'>
               <TextField 
                    id="Designation"
                    name="Designation"
                    label="Designation"
                    variant="outlined"
                    className='SecondRowStepper'
                    value={"Sales Employee"}
                    autoComplete='off'
                    />
            </div>
            <div className='errorTextField textfieldAttendance position-relative'>
               <TextField 
                    id="DayAttendance"
                    name="DayAttendance"
                    label="Day Attendance"
                    variant="outlined"
                    className='SecondRowStepper'
                    autoComplete='off'
                    value={attendanceValue ? attendanceValue : ""}
                    onClick={handleShow}
                    />
                {show &&
                <div className='attendanceDrop'>
                    <ul ref={wrapperRef}>
                     {attendanceList.map((item, index)=>(
                      <li className="list" key={index} onClick={() => handleAttenClick(item)}>{item.name}</li>
                     ))} 
                    </ul>
                </div>
              }
            </div>
            <div>
              {!checkInData ?
                <button onClick={handleCheckIN} className='attendanceCheck'>Check In</button>
              : <button onClick={handleCheckOut} className='attendanceCheck'>Check Out</button> }
            </div>
            </div>
            <div className='locationMainDiv'>
                {locationData &&
               <TextField 
                    id="Location"
                    name="Location"
                    label="Location"
                    value={locationData.locality}
                    variant="outlined"
                    className='locationText'
                    />
                }
                {/* </div> */}
                
            </div>
            <div className='locationImage'>

                </div>
        </div>
        <ToastContainer/> 
    {/* <LoadScript googleMapsApiKey="AIzaSyAmGuzIp98mJ57ikJUtckvMK4FdPN8kvl8">
    <GoogleMap
      mapContainerStyle={{ height: '400px', width: '100%' }}
      center={location}
      zoom={10}
    >
        <Marker position={location}/>
    </GoogleMap>
  </LoadScript> */}
  </div>
  <Footer/>
  </>
  )
}

export default Attendance;